import React, { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import AwardeeCard from "./AwardeeCard";

const RecentAwardeeSummary = (props) => {
  

  return (
    <HeaderComponent
      title="Recent Award Winners"
      titleClass="text-[16px] font-medium"
      description="Celebrating our exceptional team members"
      descriptionClass="text-sm"
    >
      <div className="max-h-[600px] overflow-y-auto">
        <AwardeeCard/>
      </div>
    </HeaderComponent>
  );
};

export default RecentAwardeeSummary;
